// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"ec963323","571":"ec963323"}[chunkId] + ".chunk.css";
};